export default __webpack_public_path__ + "static/media/quiz.531a6430.jpg";